<template>
  <div id="order">
    <div class="head-box">
      <h4>{{ title || '订单列表' }}</h4>
      <div class="c-flex" style="align-items: center;">
        <el-dropdown class="c-m-r-10" @command="handleMarkTag" v-if="osg.has('OrderList,markTag')">
          <el-button type="primary">标记</el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item, tagIndex) in options['orderTag']">
              <el-dropdown-item :key="tagIndex" :command="item.value">
                {{ item.label }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>

        <el-select
          style="margin-right: 10px"
          v-model="searchStateValue"
          v-if="state != 'archived'"
          placeholder="筛选条件"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in [
              { name: '全部订单', value: '0,1' },
              { name: '无效订单', value: '0' },
              { name: '有效订单', value: '1' }
            ]"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-input
          style="width:280px"
          :placeholder="`请输入客户名称/手机号/编号`"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-select
          v-if="tenantId == '1340835581184723420'"
          style="margin-left:10px"
          v-model="searchType"
          placeholder="筛选条件"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in [
              { name: '全部', value: '' },
              { name: '报价单', value: '0' },
              { name: '订单', value: '1' }
            ]"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="doNew" class="c-m-l-10" v-if="false">新增订单</el-button>
        <el-button
          v-if="osg.has('OrderList,export')"
          type="primary"
          @click="
            osg.doExport(
              Object.assign(
                {
                  'fpi-regex:ownerName|string#or': searchValue,
                  'fpi-regex:ownerPhone|string#or': searchValue,
                  'fpi-regex:_id|string#or': searchValue,
                  'fpi-is:type|integer#and': searchType,
                  'regex:exts.clientname|string#or': searchValue,
                  'regex:exts.companyName|string#or': searchValue,
                  'regex:contractNum|string#or': searchValue,
                  'in:state|array-integer#and': state == 'archived' ? '-1' : searchStateValue, //根据归档状态过滤订单状态
                  beanName: 'order',
                  title: '订单列表'
                },
                queryData
              ),
              { dynamic: true }
            )
          "
          class="c-m-l-10"
        >
          数据导出
        </el-button>
        <!-- <el-button v-if="osg.has('OrderList,exportNew')" type="primary" @click="exportNew()">
          数据导出(新)
        </el-button> -->
        <el-dropdown
          style="margin-left:10px
        "
        >
          <el-button type="primary" v-if="osg.has('OrderList,wxExport')">
            导出
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <!-- v-if="osg.has('OrderList,wxExport')" -->
            <el-dropdown-item v-if="osg.has('OrderList,wxExport')" @click.native="exportNew()">
              维修导出(旧)
            </el-dropdown-item>
            <el-dropdown-item
              v-if="osg.has('OrderList,wxExport')"
              @click.native="
                osg.export(
                  '',
                  {
                    page: fpi.page || 1,
                    rows: fpi.rows || 20,
                    'in:state|array-integer': '1',
                    'regex:ownerName|string#or': searchValue,
                    'regex:ownerPhone|string#or': searchValue,
                    'regex:_id|string#or': searchValue,
                    'is:type|integer#and': searchType,
                    'regex:exts.clientname|string#or': searchValue,
                    'regex:exts.companyName|string#or': searchValue,
                    'regex:contractNum|string#or': searchValue,
                    sortField: 'createTime',
                    sortOrder: 'desc'
                  },
                  {
                    hash: '/privatization/yuhongfangshui/export/8191527117502723955.do',
                    noFilter: true
                  }
                )
              "
            >
              维修导出(新)
            </el-dropdown-item>
            <el-dropdown-item
              v-if="osg.has('OrderList,mfExport')"
              @click.native="
                osg.export(
                  '',
                  {
                    page: fpi.page || 1,
                    rows: fpi.rows || 20,
                    'in:state|array-integer': '1',
                    'regex:ownerName|string#or': searchValue,
                    'regex:ownerPhone|string#or': searchValue,
                    'regex:_id|string#or': searchValue,
                    'is:type|integer#and': searchType,
                    'regex:exts.clientname|string#or': searchValue,
                    'regex:exts.companyName|string#or': searchValue,
                    'regex:contractNum|string#or': searchValue,
                    sortField: 'createTime',
                    sortOrder: 'desc'
                  },
                  {
                    hash: '/privatization/yuhongfangshui/export/7479703534058845803.do',
                    noFilter: true
                  }
                )
              "
            >
              美缝导出
            </el-dropdown-item>
            <el-dropdown-item
              v-if="osg.has('OrderList,sgExport')"
              @click.native="
                osg.export(
                  '',
                  {
                    page: fpi.page || 1,
                    rows: fpi.rows || 20,
                    'in:state|array-integer': '1',
                    'regex:ownerName|string#or': searchValue,
                    'regex:ownerPhone|string#or': searchValue,
                    'regex:_id|string#or': searchValue,
                    'is:type|integer#and': searchType,
                    'regex:exts.clientname|string#or': searchValue,
                    'regex:exts.companyName|string#or': searchValue,
                    'regex:contractNum|string#or': searchValue,
                    sortField: 'createTime',
                    sortOrder: 'desc'
                  },
                  {
                    hash: '/privatization/yuhongfangshui/export/20151276423303110.do',
                    noFilter: true
                  }
                )
              "
            >
              施工导出
            </el-dropdown-item>
            <el-dropdown-item
              v-if="osg.has('OrderList,sgExport')"
              @click.native="
                osg.export(
                  '',
                  {
                    page: fpi.page || 1,
                    rows: fpi.rows || 20,
                    'in:state|array-integer': '1',
                    'regex:ownerName|string#or': searchValue,
                    'regex:ownerPhone|string#or': searchValue,
                    'regex:_id|string#or': searchValue,
                    'is:type|integer#and': searchType,
                    'regex:exts.clientname|string#or': searchValue,
                    'regex:exts.companyName|string#or': searchValue,
                    'regex:contractNum|string#or': searchValue,
                    sortField: 'createTime',
                    sortOrder: 'desc'
                  },
                  {
                    hash: '/privatization/yuhongfangshui/export/1558234036203011175.do',
                    noFilter: true
                  }
                )
              "
            >
              家装导出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          @selection-change="selectionChange"
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-show="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column
            type="selection"
            fixed
            width="55"
            v-if="osg.has('OrderList,markTag')"
          ></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="dop(scope.row)">
                    查看
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('OrderList,able') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('OrderList,able') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('OrderList,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档')"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('OrderList?state=archived,recover') && state == 'archived'"
                    @click.native="doArchive(scope.row, '恢复')"
                  >
                    恢复
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('OrderList,exception')"
                    @click.native="openBizStackTrace(scope.row)"
                  >
                    业务跟踪
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <!-- <el-table-column
            v-if="tenantId == '1340835581184723420'"
            prop="type"
            label="类型"
            min-width="120px"
            :formatter="formatterOrderType"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="state"
            label="状态"
            min-width="120px"
            v-if="tenantId == '1340835581184723420' || tenantId == '4551453470943235290'"
          >
            <template slot-scope="scope">
              <el-tag effect="dark" :type="scope.row.state == '1' ? 'success' : 'info'">
                {{ scope.row.state == '1' ? '有效' : '无效' }}
              </el-tag>
            </template>
          </el-table-column> -->

          <!-- <el-table-column
            prop="contractNum"
            label="合同编号"
            v-if="tenantId != '4551453470943235290'"
            min-width="220px"
          ></el-table-column> -->
          <!-- <el-table-column prop="_id" label="订单编号" width="150px"></el-table-column> -->
          <!-- <el-table-column
            prop="createTime"
            label="创建时间"
            width="100px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            v-if="tenantId != '4551453470943235290'"
            prop="createUserName"
            :label="tenantId != '1340835581184723420' ? '下单人' : '创建人'"
            min-width="200px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="payState"
            label="支付状态"
            min-width="90px"
            :formatter="formatterpayState"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="description"
            label="备注"
            min-width="100px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            v-if="tenantId != '1340835581184723420'"
            prop="productIds"
            label="产品内容"
            :formatter="formatterProductIds"
            width="200px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="originPrice"
            label="优惠前金额"
            width="120px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="totalPrice"
            label="总金额"
            width="120px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="paidAmount"
            label="已收款金额"
            width="120px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              :prop="(extFiel.preset ? '' : 'exts.') + extFiel.name"
              show-overflow-tooltip
              :label="extFiel.nameDisp"
              :key="index"
              v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
            >
              <template slot-scope="scope">
                {{
                  formatterCodelabel(
                    scope.row.exts[extFiel.name],
                    extFiel.valueOption,
                    extFiel.type
                  )
                }}
              </template>
            </el-table-column>
          </template> -->

          <c-table :fields="extFields">
            <template slot="ownerName">
              <el-table-column
                prop="ownerName"
                :label="tenantId != '1340835581184723420' ? '客户姓名' : '委托方'"
                min-width="120px"
                :formatter="formatterClient"
              ></el-table-column>
            </template>
            <template slot="ownerPhone">
              <el-table-column label="客户电话" width="120px">
                &nbsp;
                <template slot-scope="scope">
                  <template v-if="scope.row.ownerPhone">
                    {{ scope.row.ownerPhone }}
                  </template>
                  <template v-else>
                    <el-popover
                      placement="top-start"
                      trigger="click"
                      :content="privateNumber.phone"
                    >
                      <el-button
                        slot="reference"
                        size="mini"
                        @click="
                          osg.getPrivateNumber(
                            '1',
                            null,
                            scope.row.ownerId,
                            scope.row.serviceAppointmentId
                          )
                        "
                      >
                        查看中间号
                      </el-button>
                    </el-popover>
                  </template>
                </template>
              </el-table-column>
            </template>
            <template slot="productIds">
              <el-table-column
                prop="productIds"
                label="产品内容"
                :formatter="formatterProductIds"
                width="200px"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </c-table>
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="订单信息" :visible.sync="openDetailbs">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
        class="c-pointer-n"
      >
        <el-form-item
          label="客户"
          prop="ownerName"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '客户不能为空'
          }"
        >
          <el-input v-model="formData.ownerName"></el-input>
        </el-form-item>
        <el-form-item
          label="下单人"
          prop="createUserName"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '下单人不能为空'
          }"
        >
          <el-input v-model="formData.createUserName"></el-input>
        </el-form-item>
        <el-form-item
          label="客户电话"
          prop="ownerPhone"
          :rules="{
            required: true,
            trigger: 'blur',
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码'
          }"
        >
          <el-input v-model="formData.ownerPhone"></el-input>
        </el-form-item>
        <el-form-item
          label="总金额"
          prop="originPrice"
          :rules="{
            required: true,
            trigger: 'blur',
            pattern: /^\d+$/,
            message: '请输入纯数字的总金额'
          }"
        >
          <el-input v-model="formData.originPrice"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="false">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="产品信息" :visible.sync="openDetail">
      <div style="margin-bottom: 20px;font-size: 18px;" v-if="formData.contractNum">
        合同编号：{{ formData.contractNum }}
      </div>
      <div style="margin-bottom: 15px;font-size: 18px;">
        产品内容：{{ formatterProductIds(null, null, formData.productIds) }}
      </div>
      <div v-if="bjProducts.orderList">
        <div class="c-order" v-for="(order, i) in bjProducts.orderList" :key="i">
          <template v-if="tenantId == '1340835581184723420'">
            <template v-if="formData.exts.serviceType == '8191527117502723955'">
              <div>维修部位：{{ order.constructionLocation }}</div>
              <div v-if="order.partDescription">部位描述：{{ order.partDescription }}</div>
            </template>
            <template v-else>
              <div>
                施工位置：{{ order.constructionLocation }}
                <span v-if="order.otherConstructionLocation">
                  （{{ order.otherConstructionLocation }}）
                </span>
              </div>
              <div v-if="order.partDescription">位置描述：{{ order.partDescription }}</div>
              <div>施工部位：{{ order.constructionSite }}</div>
            </template>
            <div v-if="order.agelimit || order.agelimit === 0">
              质保年限：{{ osg.codelabel('agelimit', String(order.agelimit)) }}
            </div>
            <div style="margin-bottom:10px">质保工程量：{{ order.maintainAreaNum }}平米</div>
          </template>
          <!-- 工序详情 -->
          <template v-if="order.procedures.data.length > 0">
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>工序管理</span>
            </div>
            <el-table style="width: 100%;margin-bottom: 20px;" :data="order.procedures.data">
              <el-table-column
                prop="content"
                label="服务内容"
                fixed
                width="300px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="desc"
                label="服务描述"
                width="300px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
              <el-table-column prop="number" label="工程量" show-overflow-tooltip></el-table-column>
              <el-table-column prop="totalAmount" label="合价"></el-table-column>
            </el-table>
          </template>

          <!-- 材料详情 -->
          <template v-if="order.materials.data.length > 0">
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>材料管理</span>
            </div>
            <el-table style="width: 100%;margin-bottom: 20px;" :data="order.materials.data">
              <el-table-column
                prop="name"
                label="材料名称"
                fixed
                width="300px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="spec" label="规格" width="300px"></el-table-column>
              <el-table-column
                prop="materialUnit"
                label="单位"
                :formatter="formatMaterialUnit"
              ></el-table-column>
              <el-table-column prop="number" label="数量" show-overflow-tooltip></el-table-column>
              <el-table-column
                prop="totalAmount"
                label="合价"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </template>

          <!-- 机措详情 -->
          <template v-if="order.measures.data.length > 0">
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>机措管理</span>
            </div>
            <el-table style="width: 100%;margin-bottom: 20px;" :data="order.measures.data">
              <el-table-column
                prop="content"
                label="服务内容"
                fixed
                width="300px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="desc"
                label="机措类型描述"
                fixed
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
              <el-table-column prop="number" label="数量" show-overflow-tooltip></el-table-column>
              <el-table-column
                prop="totalAmount"
                label="合价"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </template>

          <!-- 套餐详情 -->
          <template v-if="order.projPackages.data.length > 0">
            <div>
              <i class="el-icon-info" style="margin-right: 6px;"></i>
              <span>套餐详情</span>
            </div>
            <el-table
              :data="order.projPackages.data"
              style="width: 100%;margin-bottom: 20px;"
              highlight-current-row
            >
              <el-table-column type="expand" width="50">
                <template slot-scope="props">
                  <!-- 工序 -->
                  <el-table
                    v-if="props.row.procedureList.length > 0"
                    :data="props.row.procedureList"
                    style="width: 100%;margin: 0 0 20px 50px;"
                  >
                    <el-table-column prop="procedure.content" label="工序内容"></el-table-column>
                    <el-table-column
                      prop="procedure.unit"
                      label="单位"
                      :formatter="formatUnit"
                    ></el-table-column>
                    <el-table-column prop="number" label="数量"></el-table-column>
                    <el-table-column
                      prop="procedure.desc"
                      label="服务描述"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                  <!-- 材料 -->
                  <div
                    data-v-f3f6c0be=""
                    class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table--small"
                    style="width: calc(100% - 50px); margin: 0px 0px 20px 50px;"
                  >
                    <div class="hidden-columns">
                      <div data-v-f3f6c0be=""></div>
                      <div data-v-f3f6c0be=""></div>
                      <div data-v-f3f6c0be=""></div>
                    </div>
                    <div class="el-table__header-wrapper">
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        class="el-table__header"
                        style="width:100%"
                      >
                        <colgroup>
                          <col name="el-table_52_column_395" />
                          <col name="el-table_52_column_396" />
                          <col name="el-table_52_column_397" />
                        </colgroup>
                        <thead class="">
                          <tr class="">
                            <th
                              colspan="1"
                              rowspan="1"
                              class="el-table_52_column_395 is-leaf el-table__cell"
                            >
                              <div class="cell">材料名称</div>
                            </th>
                            <th
                              colspan="1"
                              rowspan="1"
                              class="el-table_52_column_396 is-leaf el-table__cell"
                            >
                              <div class="cell">单位</div>
                            </th>
                            <th
                              colspan="1"
                              rowspan="1"
                              class="el-table_52_column_397 is-leaf el-table__cell"
                            >
                              <div class="cell">数量</div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="el-table__body-wrapper is-scrolling-none">
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        class="el-table__body"
                        style="width:100%"
                      >
                        <colgroup>
                          <col name="el-table_52_column_395" />
                          <col name="el-table_52_column_396" />
                          <col name="el-table_52_column_397" />
                        </colgroup>
                        <tbody>
                          <template v-for="(m, mIndex) in props.row.materialList">
                            <template v-if="m.skus && m.skus.length > 0">
                              <tr
                                class="el-table__row expanded"
                                v-for="(sku, skuIndex) in m.skus"
                                :key="skuIndex"
                              >
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_395 el-table__cell"
                                >
                                  <div class="cell">{{ sku.name }}</div>
                                </td>
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_396 el-table__cell"
                                >
                                  <div class="cell">
                                    {{ formatMaterialUnit(null, null, sku.materialUnit) }}
                                  </div>
                                </td>
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_397 el-table__cell"
                                >
                                  <div class="cell">{{ sku.number }}</div>
                                </td>
                              </tr>
                            </template>

                            <template v-else>
                              <tr class="el-table__row expanded" :key="mIndex">
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_395 el-table__cell"
                                >
                                  <div class="cell">{{ m.material.name }}</div>
                                </td>
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_396 el-table__cell"
                                >
                                  <div class="cell">
                                    {{ formatMaterialUnit(null, null, m.material.materialUnit) }}
                                  </div>
                                </td>
                                <td
                                  rowspan="1"
                                  colspan="1"
                                  class="el-table_52_column_397 el-table__cell"
                                >
                                  <div class="cell">{{ m.number }}</div>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- 机措 -->
                  <el-table
                    v-if="props.row.measureList.length > 0"
                    :data="props.row.measureList"
                    style="width: 100%;margin: 0 0 20px 50px;"
                  >
                    <el-table-column
                      prop="measure.content"
                      label="机措内容"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="measure.unit"
                      label="单位"
                      :formatter="formatUnit"
                    ></el-table-column>
                    <el-table-column
                      prop="measure.desc"
                      label="机措类型描述"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="number"
                      label="数量"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="套餐名称" min-width="220"></el-table-column>
              <el-table-column
                prop="minimumPrice"
                label="最低起算价"
                min-width="120"
              ></el-table-column>
              <el-table-column prop="number" label="工程量" min-width="120"></el-table-column>
              <el-table-column prop="totalAmount" label="总价" min-width="120"></el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div v-else>
        <!-- 工序详情 -->
        <template v-if="bjProducts.procedures.data.length > 0">
          <div>
            <i class="el-icon-info" style="margin-right: 6px;"></i>
            <span>工序管理</span>
          </div>
          <el-table style="width: 100%;margin-bottom: 20px;" :data="bjProducts.procedures.data">
            <el-table-column
              prop="content"
              label="服务内容"
              fixed
              width="300px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="desc"
              label="服务描述"
              width="300px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
            <el-table-column prop="number" label="工程量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalAmount" label="合价"></el-table-column>
          </el-table>
        </template>

        <!-- 材料详情 -->
        <template v-if="bjProducts.materials.data.length > 0">
          <div>
            <i class="el-icon-info" style="margin-right: 6px;"></i>
            <span>材料管理</span>
          </div>
          <el-table style="width: 100%;margin-bottom: 20px;" :data="bjProducts.materials.data">
            <el-table-column
              prop="name"
              label="材料名称"
              fixed
              width="300px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="spec" label="规格" width="300px"></el-table-column>
            <el-table-column
              prop="materialUnit"
              label="单位"
              :formatter="formatMaterialUnit"
            ></el-table-column>
            <el-table-column prop="number" label="数量" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="totalAmount"
              label="合价"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </template>

        <!-- 机措详情 -->
        <template v-if="bjProducts.measures.data.length > 0">
          <div>
            <i class="el-icon-info" style="margin-right: 6px;"></i>
            <span>机措管理</span>
          </div>
          <el-table style="width: 100%;margin-bottom: 20px;" :data="bjProducts.measures.data">
            <el-table-column
              prop="content"
              label="服务内容"
              fixed
              width="300px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="desc"
              label="机措类型描述"
              fixed
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
            <el-table-column prop="number" label="数量" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="totalAmount"
              label="合价"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </template>

        <!-- 套餐详情 -->
        <template v-if="bjProducts.projPackages.data.length > 0">
          <div>
            <i class="el-icon-info" style="margin-right: 6px;"></i>
            <span>套餐详情</span>
          </div>
          <el-table
            :data="bjProducts.projPackages.data"
            style="width: 100%;margin-bottom: 20px;"
            highlight-current-row
          >
            <el-table-column type="expand" width="50">
              <template slot-scope="props">
                <!-- 工序 -->
                <el-table :data="props.row.procedureList" style="width: 100%;margin-bottom: 20px;">
                  <el-table-column prop="procedure.content" label="工序内容"></el-table-column>
                  <el-table-column
                    prop="procedure.unit"
                    label="单位"
                    :formatter="formatUnit"
                  ></el-table-column>
                  <el-table-column prop="number" label="数量"></el-table-column>
                  <el-table-column
                    prop="procedure.desc"
                    label="服务描述"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
                <!-- 材料 -->
                <el-table :data="props.row.materialList" style="width: 100%;margin-bottom: 20px;">
                  <el-table-column prop="material.name" label="材料名称"></el-table-column>
                  <el-table-column
                    prop="material.materialUnit"
                    label="单位"
                    :formatter="formatMaterialUnit"
                  ></el-table-column>
                  <el-table-column prop="number" label="数量"></el-table-column>
                </el-table>
                <!-- 机措 -->
                <el-table :data="props.row.measureList" style="width: 100%;margin-bottom: 20px;">
                  <el-table-column
                    prop="measure.content"
                    label="机措内容"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="measure.unit"
                    label="单位"
                    :formatter="formatUnit"
                  ></el-table-column>
                  <el-table-column
                    prop="measure.desc"
                    label="机措类型描述"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="number"
                    label="数量"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="套餐名称" min-width="220"></el-table-column>
            <el-table-column
              prop="minimumPrice"
              label="最低起算价"
              min-width="120"
            ></el-table-column>
            <el-table-column prop="number" label="工程量" min-width="120"></el-table-column>
            <el-table-column prop="totalAmount" label="总价" min-width="120"></el-table-column>
          </el-table>
        </template>
      </div>

      <template v-if="originalOrder.length > 0">
        <div>
          <i class="el-icon-info" style="margin-right: 6px;"></i>
          <span>原订单细项列表</span>
        </div>
        <el-table
          :data="originalOrder"
          style="width: 100%;margin-bottom: 20px;"
          highlight-current-row
        >
          <el-table-column type="expand" width="50">
            <template slot-scope="props">
              <el-table
                :data="props.row.product.materials"
                style="width: 100%;margin-bottom: 20px;"
              >
                <el-table-column
                  prop="material.name"
                  label="材料名称"
                  min-width="220"
                ></el-table-column>
                <el-table-column
                  prop="consumption"
                  label="材料消耗量"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="material.price"
                  label="材料单价"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="material.spec"
                  label="规格"
                  min-width="180"
                ></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="product.name" label="产品名称" min-width="220"></el-table-column>
          <el-table-column prop="number" label="数量" min-width="120"></el-table-column>
          <el-table-column prop="product.price" label="产品单价" min-width="120"></el-table-column>
          <el-table-column
            prop="product.description"
            label="产品描述"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </template>

      <template
        v-if="bjProducts.addItems.data.length > 0 || bjProducts.deleteItems.data.length > 0"
      >
        <div>
          <i
            class="el-icon-info"
            style="height:60px;line-height:60px;margin-right: 6px;margin-left: 8px;"
          ></i>
          <span>增减项细项列表</span>
        </div>
        <el-table style="width: 100%;margin-bottom: 20px;" :data="bjProducts.addItems.data">
          <el-table-column
            prop="name"
            label="增项名称"
            fixed
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="totalAmount" label="合价"></el-table-column>
        </el-table>
        <el-table style="width: 100%;margin-bottom: 20px;" :data="bjProducts.deleteItems.data">
          <el-table-column
            prop="name"
            label="减项名称"
            fixed
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="totalAmount" label="合价"></el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <el-dialog
      title="业务跟踪"
      :visible.sync="bizStackTraceOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="bizStackTraceDialog"
    >
      <bizStackTrace :params="{ sid: formData._id }" v-if="bizStackTraceOpen"></bizStackTrace>
      <div slot="footer" v-if="false">
        <el-button @click="bizStackTraceOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'orderList',
  components: {
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  data() {
    return {
      name: 'order',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      extFieldsData: [], //动态列表用到
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        codecfg_orderType: { codeId: 'orderType' },
        codecfg_payState: { codeId: 'PAYSTATE' },
        codecfg_orderTag: { codeId: 'orderTag' }, //订单标记
        codecfg_unit: { codeId: 'company' },
        codecfg_materialUnit: { codeId: 'company' },
        codecfg_type: { codeId: 'type1' },
        codecfg_agelimit: { codeId: 'agelimit' }
      },
      state: '', //归档状态
      contactList: [],
      params: {},
      originalOrder: [], //原订单
      newOrder: [], //增减项订单
      bjProducts: {
        procedures: {
          data: []
        },
        materials: {
          data: []
        },
        measures: {
          data: []
        },
        projPackages: {
          data: []
        },
        addItems: {
          data: []
        },
        deleteItems: {
          data: []
        }
      },
      searchType: '',
      tenantId: '', //租户id
      openDetailbs: false, // 闭水的弹窗
      /**
       * 中间号
       */
      privateNumber: {
        phone: ''
      },
      bizStackTraceOpen: false,
      searchStateValue: '1',
      selectedList: [], //选择列表
      queryData: {}, //地址过滤参数
      title: '' //标题
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;
    this.osg.getFields('order', () => {
      this.osg.getFpi();
      this.getData();
      this.options['orderTag'].unshift({ label: '取消标记', value: '' });
    });
  },
  methods: {
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:ownerName|string#or': this.searchValue,
        'regex:ownerPhone|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        'is:type|integer#and': this.searchType,
        'regex:exts.clientname|string#or': this.searchValue,
        'regex:exts.companyName|string#or': this.searchValue,
        'regex:contractNum|string#or': this.searchValue,
        'in:state|array-integer#and': this.state == 'archived' ? '-1' : this.searchStateValue, //根据归档状态过滤订单状态
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      params = Object.assign(params, this.queryData);
      this.osg.ajax('basic/order/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.state = this.osg.param('state');
      this.state = this.$route.query.state;
      this.title = this.$route.query.title;
      this.queryData = {}; //根据地址栏参数 添加到getData里
      for (let key in this.$route.query) {
        key = decodeURIComponent(key);
        if (key.indexOf('|') != -1) {
          this.queryData[key] = this.$route.query[key];
        }
      }
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    //打开业务跟踪弹窗
    openBizStackTrace(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.bizStackTraceOpen = true;
    },
    //查看订单详情
    dop(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.newOrder = [];
      this.originalOrder = [];
      if (row.bjProducts && this.$util.isJson(row.bjProducts)) {
        this.bjProducts = JSON.parse(row.bjProducts);
      } else {
        row.productsDetail.forEach(item => {
          if (item.product.exts && item.product.exts.laterItem) {
            this.newOrder.push(item);
          } else {
            this.originalOrder.push(item);
          }
        });
      }
      if (this.tenantId == '1340835581184723420') {
        this.openDetail = true;
      } else {
        this.openDetailbs = true;
      }
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        this.osg.ajax('basic/order/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //被选中的订单
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //标记功能
    handleMarkTag(command) {
      let tagTimeList = []; //标记时间
      this.selectedList.forEach(item =>
        tagTimeList.push({
          id: item._id,
          name: 'orderTagTime',
          value: command === '' ? '' : this.$util.readableTime(),
          className: 'com.fsgo.entity.basic.Order'
        })
      );
      //标记标签
      let tagList = this.selectedList.map(item => {
        return {
          id: item._id,
          name: 'orderTag',
          value: command,
          className: 'com.fsgo.entity.basic.Order'
        };
      });
      tagList = tagList.concat(tagTimeList);
      if (tagList && tagList.length) {
        console.log(tagList);
        this.markTagAjax(JSON.stringify(tagList));
      } else {
        this.osg.toast('请至少选择一个！', 'warning');
      }
    },
    //调用标记接口
    markTagAjax(data) {
      this.osg.confirm('确定标记这些吗？', () => {
        this.osg.ajax('i/markEmbodiment/all.do', { data }, res => {
          this.selectedList = [];
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doEnable(id) {
      this.osg.ajax('basic/order/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/order/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //归档/恢复接口
    doArchive(row, msg) {
      this.osg.confirm(`是否确认${msg}订单？`, () => {
        this.osg.ajax('basic/order/archive/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg}订单`);
        });
      });
    },
    /**
     * 数据导出
     */
    exportNew() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer': 1,
        'regex:ownerName|string#or': this.searchValue,
        'regex:ownerPhone|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        'is:type|integer#and': this.searchType,
        'regex:exts.clientname|string#or': this.searchValue,
        'regex:exts.companyName|string#or': this.searchValue,
        'regex:contractNum|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:exts.serviceType|string#and': '8191527117502723955'
      };
      // window.$that.getParams(params);
      // this.osg.setFpi(params);
      debugger;
      params = Object.assign(params, this.queryData);
      this.osg.ajax(
        'basic/order/export.do',
        params,
        res => {
          this.offlineExportBack();
        },
        {
          responseType: 'blob'
        }
      );
    },
    //导出成功回调
    offlineExportBack() {
      this.osg.alert('操作成功！正在生成文件... 点击跳转查看', () => {
        this.$router.push({ path: '/Stask' });
      });
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderType', cellValue);
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatMaterialUnit(row, column, cellValue) {
      return this.osg.codelabel('materialUnit', cellValue);
    },
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    //委托方特殊逻辑
    formatterClient(row, column, cellValue) {
      if (this.tenantId == '1340835581184723420') {
        if (row.exts.personType == '0') {
          return row.exts.clientname;
        } else {
          return row.exts.companyName;
        }
      }
      return cellValue;
    },
    formatterpayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (
        type == 'cascade' &&
        ((cellValue && cellValue.indexOf(',') != -1) || Array.isArray(cellValue))
      ) {
        let value = Array.isArray(cellValue) ? cellValue : cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    formatterProductIds(row, column, cellValue) {
      if (cellValue) {
        let ProductIds = JSON.parse(cellValue);
        let ProductNames = Array.isArray(ProductIds)
          ? ProductIds.map(item => item.name).join(',')
          : cellValue;
        return ProductNames;
      } else {
        return cellValue;
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    //表格刷新
    Refresh() {
      this.refresh = false;
      this.$nextTick(function() {
        this.refresh = true;
      });
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.doInit();
      this.osg.getFpi();
      this.getData();
      this.Refresh();
    }
  }
};
</script>
<style scoped>
input.el-input__inner {
  width: 230px;
}
</style>
<style lang="scss">
.header-50 {
  height: 51px !important;
}
#app #order .el-dialog {
  width: 76% !important;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    padding: 15px;
  }
  .c-order {
    margin: 10px 0 20px;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    padding: 10px;
  }
}
#app #bizStackTraceDialog > .el-dialog {
  width: 100% !important;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
</style>
